import { CheckCircle, XCircle, Clock } from 'lucide-react';

export function StatusBadge({ status, type = 'acceptance' }) {
  const config = type === 'acceptance' ? {
    accepted: { bg: 'bg-emerald-100', text: 'text-emerald-700', icon: CheckCircle },
    rejected: { bg: 'bg-red-100', text: 'text-red-700', icon: XCircle },
    pending: { bg: 'bg-amber-100', text: 'text-amber-700', icon: Clock }
  } : type === 'delivery' ? {
    delivered: { bg: 'bg-emerald-100', text: 'text-emerald-700', icon: CheckCircle },
    completed: { bg: 'bg-emerald-100', text: 'text-emerald-700', icon: CheckCircle },
    in_progress: { bg: 'bg-blue-100', text: 'text-blue-700', icon: Clock },
    pending: { bg: 'bg-amber-100', text: 'text-amber-700', icon: Clock }
  } : {
    paid: { bg: 'bg-emerald-100', text: 'text-emerald-700', icon: CheckCircle },
    pending: { bg: 'bg-slate-100', text: 'text-slate-700', icon: Clock }
  };
  const { bg, text, icon: Icon } = config[status] || config.pending;
  const label = !status ? 'Pending' : status === 'in_progress' ? 'In Progress' : status === 'completed' ? 'Delivered' : status.charAt(0).toUpperCase() + status.slice(1);
  return (
    <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold ${bg} ${text}`}>
      <Icon className="w-3 h-3" />{label}
    </span>
  );
}

export function FieldError({ error }) {
  if (!error) return null;
  return <p className="text-red-500 text-xs mt-1">{error}</p>;
}
